import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse, HttpInterceptorFn, HttpStatusCode } from '@angular/common/http';
import { PLATFORM_ID, inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { MessageService } from 'primeng/api';

import { AuthStore } from './auth.store';

const TOKEN_STORAGE_KEY = 'auth_token';

export const httpErrorInterceptor: HttpInterceptorFn = (request, next) => {
    const authStore = inject(AuthStore);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);
    const messageService = inject(MessageService);

    return next(request).pipe(
        catchError((error: unknown) => {
            if (!(error instanceof HttpErrorResponse)) {
                return throwError(() => new Error('Erro inesperado de comunicação.'));
            }

            if (error.status === HttpStatusCode.Unauthorized) {
                authStore.clear();

                if (isPlatformBrowser(platformId)) {
                    localStorage.removeItem(TOKEN_STORAGE_KEY);
                }

                router.navigateByUrl('/auth/login');
            }

            const errorMessage = extractErrorMessage(error);

            messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail: errorMessage
            });

            return throwError(() => error);
        })
    );
};

function extractErrorMessage(error: HttpErrorResponse): string {
    const payload = error.error;

    if (typeof payload === 'string' && payload.trim()) {
        return payload;
    }

    if (payload && typeof payload === 'object' && 'message' in payload) {
        const message = (payload as { message?: unknown }).message;

        if (typeof message === 'string' && message.trim()) {
            return message;
        }
    }

    if (error.message?.trim()) {
        return error.message;
    }

    return 'Falha na requisição.';
}
